import * as React from 'react'

import { cn } from '@/lib/utils'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

const OptionsItemList: React.FC<IProps> = ({
  className,
  children,
  ...rest
}) => {
  return (
    <div
      data-slot="options-item-list"
      role="listbox"
      className={cn(
        'tw:flex tw:flex-col tw:flex-1 tw:min-h-0 tw:gap-0.5 tw:overflow-y-auto',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export default OptionsItemList
